export default function (element, data) {
    element.addEventListener("click", function (event) {
        if (element.classList.contains("open")) {
            window.dispatchEvent(new CustomEvent('close-mobile-menu'));
        } else {
            window.dispatchEvent(new CustomEvent('open-mobile-menu'));
        }
    });

    window.addEventListener("open-mobile-menu", function () {
        element.classList.add("open");
    });

    window.addEventListener("close-mobile-menu", function () {
        element.classList.remove("open");
    });
};